var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBedcardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 0.5C3.5 0.5 3 0.71 2.61 1.1C2.22 1.49 2 1.95 2 2.5V5.5C1.47 5.5 1 5.69 0.59 6.09C0.18 6.49 0 6.97 0 7.5V12.5H1.34L2 14.5H3L3.69 12.5H12.36L13 14.5H14L14.66 12.5H16V7.5C16 6.97 15.81 6.5 15.41 6.09C15.01 5.68 14.53 5.5 14 5.5V2.5C14 1.95 13.8 1.5 13.39 1.1C12.98 0.7 12.5 0.5 12 0.5M4 2.5H7V5.5H4M9 2.5H12V5.5H9M2 7.5H14V10.5H2V7.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBedcardIcon);
export default __webpack_public_path__ + "static/media/bedcardIcon.d14ac3172aae7399bf58adef29860e6b.svg";
export { ForwardRef as ReactComponent };